import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';

import { WebVitalsConfig } from './models/web-vitals-config.model';
import { onAppInit } from './on-app-init';
import { WebVitalsService } from './services/web-vitals.service';
import { WEB_VITALS_CONFIG } from './tokens/config.token';

/** Browser configs only: a browser API is used inside. */
export function provideWebVitals(
  config: WebVitalsConfig,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: WEB_VITALS_CONFIG,
      useValue: config,
    },
    provideAppInitializer(() => onAppInit(inject(WebVitalsService))),
  ]);
}
